import { InferOutput, maxValue, minValue, number, pipe } from 'valibot'

export const RoundNumberSchema = pipe(number(), minValue(1), maxValue(999))

export type RoundNumber = InferOutput<typeof RoundNumberSchema>
